import(/* webpackMode: "eager", webpackExports: ["default"] */ "/vercel/path0/app/admin/_components/auth/ProtectedRoute.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/vercel/path0/app/admin/_components/help/Help.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/vercel/path0/app/admin/_components/MenuLink.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/vercel/path0/app/admin/_components/SidebarButton.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/vercel/path0/app/admin/(dashboard)/(home)/_components/CommentsButton.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/vercel/path0/app/admin/(dashboard)/SWRProvider.tsx");
;
import(/* webpackMode: "eager" */ "/vercel/path0/node_modules/@headlessui/react/dist/components/menu/menu.js");
;
import(/* webpackMode: "eager" */ "/vercel/path0/node_modules/next/dist/client/image-component.js");
;
import(/* webpackMode: "eager" */ "/vercel/path0/node_modules/next/dist/client/link.js");
;
import(/* webpackMode: "eager" */ "/vercel/path0/public/logo-msu-white.svg");
